import axios from 'axios';
import React, { useEffect, useState } from 'react';



interface Video {
  id: number;
  title: string;
  url: string;
}

const YT = () => {
  const api = process.env.REACT_APP_API_URL as string;
   const [videos, setVideos] = useState<Video[]>([]);

    useEffect(() => {
       fetchVideos();
     }, []);
   
     const fetchVideos = async () => {
       try {
         const res = await axios.get(`${api}/auth/YTVideo`);
         setVideos(res.data);
       } catch (err) {
         console.error('Error fetching videos:', err);
       }
     };
  return (
    <div className="min-h-screen bg-[#101729] py-10 px-4">
      <h1 className="text-white text-3xl font-semibold mb-8 text-center">Featured Videos</h1>
      <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 max-w-7xl mx-auto">
        {videos.map((video: any) => {
  const getEmbedUrl = (url: string) => {
    const match = url.match(/(?:\?v=|\/embed\/|\.be\/)([a-zA-Z0-9_-]{11})/);
    const videoId = match ? match[1] : '';
    return videoId ? `https://www.youtube.com/embed/${videoId}` : '';
  };

  return (
    <div
      key={video.id}
      className="bg-[#1A2436] rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-shadow duration-300"
    >
      <div className="aspect-w-16 aspect-h-9">
        <iframe
          className="w-full h-full"
          src={getEmbedUrl(video.url)}
          title={video.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
      <div className="p-5 text-white">
        <h2 className="text-xl font-semibold mb-2">{video.title}</h2>
        <p className="text-sm text-[#CBD5E0]">{video.description}</p>
      </div>
    </div>
  );
})}

      </div>
    </div>
  );
};

export default YT;


